import React from "react";
import UserInfo from "../common/user_info";

function Investor(props) {
  return (
    <div className='member-unit col-6 col-lg-4'>
      <UserInfo {...props} />
    </div>
  );
}

export default Investor;
